import React from "react";

import { useTranslation } from "../context/Internationalization";
import { Button } from "../shadcn/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../shadcn/components/ui/dialog";

const ClubChooseConfirmationModal = ({ open, onClose, onSave, clubName }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={Boolean(open)}
      onOpenChange={(next, details) => !next && onClose?.(details?.event)}
    >
      <DialogContent closeLabel={t("close")}>
        <DialogHeader>
          <DialogTitle>{t("choose_club_modal_title")}</DialogTitle>
          <DialogDescription>
            {`${t("choose_club_confirmation_msg1")} ${clubName?.trim("")}. ${t(
              "choose_club_confirmation_msg2"
            )}`}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>
            {t("close")}
          </Button>
          <Button type="button" onClick={() => onSave()}>
            {t("save")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ClubChooseConfirmationModal;
